import Box from '@mui/material/Box'
import { styled, ThemeProvider, createTheme } from '@mui/material/styles'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import ArrowRight from '@mui/icons-material/ArrowRight'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import LogoutIcon from '@mui/icons-material/Logout'

/* ----------------------------------- REDUX ---------------------------------- */
import { useDispatch, useSelector } from 'react-redux'
import { LogOutUser } from '../../redux/actions/User'

import { Avatar, ImageListItem } from '@mui/material'

import miestudio from '../../images/LogoErreparPlus.png'
import { ItemMenu } from './ListMenu'
import { useNavigate } from 'react-router-dom'
import { menuItems } from './ItemsMenuData'
import useStyleMenu from './Styles/useStyleMenu'
import { useCookies } from 'react-cookie'
import { useState, useEffect } from 'react'
import { getNameUserLogged } from '../../utils/UserTools'
// decode token
// eslint-disable-next-line
import jwt_decode from "jwt-decode";
import parser from '../../utils/Parser'
import { getUserRoles } from '../../utils/validateToken'

const FireNav = styled(List)({
  '& .MuiListItemButton-root': {
    paddingLeft: 24,
    paddingRight: 24
  },
  '& .MuiListItemIcon-root': {
    minWidth: 0,
    marginRight: 16
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20
  }
})

export default function MenuDesktop () {
  const [open, setOpen] = useState(true)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const classes = useStyleMenu()
  const [, , removeCookie] = useCookies(['syserrepar_JWT2'])
  const user = useSelector((state) => state.user)
  const decoded = jwt_decode(user.eAuthToken)

  const isvalidRole = (rolesValidos) => {
    let isvalid = false
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0 && rolesValidos) {
      appRoles.forEach((element) => {
        if (rolesValidos.includes(element)) isvalid = true
      })
    }
    return isvalid
  }

  const reduxLogOut = () => dispatch(LogOutUser())

  const handleLogout = () => {
    reduxLogOut()
    removeCookie('webcgi_JWT2', { domain: parser.getDomain() })
    navigate('/login')
  }

  const [itemSelected, setItemSelected] = useState('')

  useEffect(() => {
    const hrefScreenActive = window.location.pathname.split('/')
    const [, b] = hrefScreenActive
    setItemSelected(b)
  }, [window.location.pathname])

  return (
    <Box className={classes.box}>
      <ThemeProvider
        theme={createTheme({
          components: {
            MuiListItemButton: {
              defaultProps: {
                disableTouchRipple: true
              }
            }
          },
          palette: {
            mode: 'dark',
            primary: { main: 'rgb(102, 157, 246)' },
            background: { paper: '#f9f9f9' }
          }
        })}
      >
        <Paper elevation={0} sx={{ maxWidth: 260, overflowY: 'auto' }}>
          <FireNav component="nav" disablePadding>
            <ListItemButton
              component="a"
              href="#customized-list"
              style={{ height: '8%' }}
            >
              <ImageListItem style={{ display: 'flex' }}>
                <img src={miestudio} style={{ width: '70%' }} />
              </ImageListItem>
            </ListItemButton>
            <Divider className={classes.dividerStyle} />
            <ListItem component="div" disablePadding>
              <ListItemButton sx={{ height: 30 }}>
                <ListItemIcon>
                  <Avatar
                    src={`${decoded.loginAccountData.basePictureURL}/fit-in/600x400${decoded.loginAccountData.profilePictureURL}`}
                    className={classes.avatarCircle}
                    alt={decoded.loginAccountData.firstName}
                    sx={{ width: 40, height: 40 }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={getNameUserLogged()}
                  primaryTypographyProps={{
                    color: '#4B4952',
                    fontWeight: 'bold',
                    variant: 'body2'
                  }}
                />
              </ListItemButton>
              <Tooltip title="Cerrar Sesión">
                <IconButton
                  size="large"
                  sx={{
                    '& svg': {
                      color: 'rgba(255,255,255,0.8)',
                      transition: '0.2s',
                      transform: 'translateX(0) rotate(0)'
                    },
                    '&:hover, &:focus': {
                      bgcolor: 'unset',
                      '& svg:first-of-type': {
                        transform: 'translateX(-4px) rotate(-20deg)'
                      },
                      '& svg:last-of-type': {
                        right: 0,
                        opacity: 1
                      }
                    },
                    '&:after': {
                      content: '""',
                      position: 'absolute',
                      height: '80%',
                      display: 'block',
                      left: 0,
                      width: '1px',
                      bgcolor: '#568C8C'
                    }
                  }}
                  onClick={handleLogout}
                >
                  <LogoutIcon style={{ color: '#568C8C' }} />
                  <ArrowRight
                    style={{ color: '#00BBAA' }}
                    className={classes.arrowRight}
                  />
                </IconButton>
              </Tooltip>
            </ListItem>
            <Divider className={classes.dividerStyle} />
            <Box
              sx={{
                bgcolor: open ? '#f9f9f9' : null,
                pb: open ? 2 : 0
              }}
            >
              <ListItemButton
                alignItems="flex-start"
                onClick={() => setOpen(!open)}
                sx={{
                  px: 3,
                  pt: 2.5,
                  pb: open ? 0 : 2.5,
                  '&:hover, &:focus': { '& svg': { opacity: open ? 1 : 0 } }
                }}
              >
                <ListItemText
                  primary="General"
                  primaryTypographyProps={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    lineHeight: '20px',
                    mb: '2px',
                    color: '#2C3532'
                  }}
                  secondary="Administrar usuarios, organizaciones, suborganizaciones, etc."
                  secondaryTypographyProps={{
                    noWrap: true,
                    fontSize: 12,
                    lineHeight: '16px',
                    color: open ? 'rgba(0,0,0,0)' : '#747F7F'
                  }}
                  sx={{ my: 0 }}
                />
                <KeyboardArrowDown
                  sx={{
                    mr: -1,
                    opacity: 0,
                    transform: open ? 'rotate(-180deg)' : 'rotate(0)',
                    transition: '0.2s'
                  }}
                />
              </ListItemButton>

              {open &&
                menuItems.map((item) => isvalidRole(item.roles) && 
                  (
                    <ItemMenu
                      key={item.label}
                      item={item}
                      itemSelected={itemSelected}
                      setItemSelected={setItemSelected}
                    />
                  )
              )}
            </Box>
            <Divider className={classes.bottomDividirStyle} />
          </FireNav>
        </Paper>
      </ThemeProvider>
    </Box>
  )
}
